// Uzywamy sciezki relatywnej, bo Nginx obsluguje proxy
const API_URL = process.env.REACT_APP_API_URL || "/api";

export async function fetchCars(queryParams = "") {
  // queryParams może być stringiem (np. "page=2") lub obiektem opcji
  let queryString = queryParams;

  if (typeof queryParams === 'object') {
    const params = new URLSearchParams();
    if (queryParams.is_sold !== undefined) {
      params.append('is_sold', queryParams.is_sold);
    }
    if (queryParams.page !== undefined) {
      params.append('page', queryParams.page);
    }
    if (queryParams.body_type !== undefined) {
      params.append('body_type', queryParams.body_type);
    }
    // Tu można dodać więcej parametrów w przyszłości
    queryString = params.toString();
  }

  const res = await fetch(`${API_URL}/listings/?${queryString}`);
  if (!res.ok) throw new Error("Błąd pobierania listy samochodów");
  return res.json();
}

export async function sendContactMessage(data) {
  const res = await fetch(`${API_URL}/contact/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || "Błąd wysyłania wiadomości");
  }
  return res.json();
}

export async function fetchCar(id) {
  const res = await fetch(`${API_URL}/listings/${id}/`);
  if (!res.ok) throw new Error("Błąd pobierania szczegółów samochodu");
  return res.json();
}